import { Form as FormShared } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/components';
import {
	Box,
	Button,
	DatePicker,
	InputField,
	InputSelect,
	Spacer,
	Typography,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { ArrowLeft } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { Link } from '@components';
import { rem } from '@helpers';
import { Anything } from '@types';

import { RequestToCallSuccess } from './block';
import { useRequestToCallCloseHelper } from './requestToCallClose.helper';

// to fix not exists children prop in react-18
const Form = FormShared as any;

export interface RequestToCallCloseProps {
	hideDisclaimer: () => void;
}

export const RequestToCallClose: React.FC<RequestToCallCloseProps> = (props) => {
	const { colorPalette } = useTheme();
	const {
		phoneCodes,
		resources,
		timeCodes,
		statusDate,
		messageErrorDate,
		form,
		agentClosedSuccess,
		isDisabled,
		popupMenuIndicativeRef,
		popupMenuTimeRef,
		calendarRef,
		datePickerRef,
		newDateToCompare,
		getInputProps,
		disableDatesFn,
		back,
		onDateChange,
		onInvalidDate,
		clearInput,
		handlePressTime,
		handlePressIndicative,
		onPressSendRequest,
	} = useRequestToCallCloseHelper(props);
	return (
		<>
			{agentClosedSuccess ? (
				<RequestToCallSuccess nameToContact={getInputProps('name').value} />
			) : (
				<Box
					styles={{
						flexDirection: 'column',
						minHeight: '100%',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Box styles={{ flexDirection: 'column', alignItems: 'center', marginBottom: rem(48) }}>
						<Typography appearance="headline-200-02">{resources.title}</Typography>
						<Spacer vertical={8} />
						<Typography appearance="body-100-02" colorToken="primary-light">
							{resources.subtitle}
						</Typography>
					</Box>
					<Form
						name={form.name}
						ref={form.ref}
						style={{ flexDirection: 'column', alignItems: 'center', width: rem(493) }}
					>
						<Box styles={{ flexDirection: 'row' }}>
							<Box styles={{ width: '50%' }}>
								<DatePicker
									mode="horizontal"
									ref={datePickerRef}
									calendar={{
										ref: calendarRef,
										selectionType: 'single',
										selection: getInputProps('date').value,
										maxDate: newDateToCompare,
										minDate: new Date(),
										onDateChange: onDateChange,
										disableDatesFn,
									}}
									invalidDate={onInvalidDate}
									input={{
										status: statusDate,
										bottomMessage: {
											text: {
												content: statusDate === 'error' ? messageErrorDate : undefined,
											},
										},
										type: 'inputField',
										label: resources.dateLabel,
									}}
								/>
							</Box>
							<Spacer horizontal={24} />
							<Box>
								<InputSelect
									ref={popupMenuTimeRef}
									mode="default"
									inputField={{
										label: resources.timeLabel,
									}}
									onPress={handlePressTime}
									popupMenu={{
										popupMenuHeight: { maxHeight: rem(150) },
										hideOnClick: true,
										items: timeCodes,
										zIndex: 10,
									}}
								/>
							</Box>
						</Box>
						<Box
							styles={{
								margin: rem(24, 0),
								width: '100%',
							}}
						>
							<Typography appearance="body-75-03">{resources.titleForm}</Typography>
						</Box>
						<Box>
							<div>
								<InputField
									mode="default"
									label={resources.inputLabelName}
									onClearButtonPress={() => {
										clearInput(getInputProps('name'));
									}}
									{...(getInputProps('name') as Anything)}
								/>
							</div>
							<Spacer horizontal={24} />
							<div>
								<InputSelect
									ref={popupMenuIndicativeRef}
									mode="default"
									inputField={{
										label: resources.inputCountry,
										containerProps: {
											width: rem(105),
										},
									}}
									onPress={handlePressIndicative}
									popupMenu={{
										popupMenuHeight: { maxHeight: rem(150) },
										hideOnClick: true,
										items: phoneCodes,
										zIndex: 10,
									}}
								/>
							</div>
							<Spacer horizontal={rem(8)} />
							<div>
								<InputField
									mode="number"
									inputProps={{
										maxLength:
											getInputProps('indicative').value === resources.indicativeGlobal
												? 9
												: undefined,
									}}
									label={resources.inputLabelContact}
									onClearButtonPress={() => {
										clearInput(getInputProps('phoneNumber'));
									}}
									{...(getInputProps('phoneNumber') as Anything)}
								/>
							</div>
						</Box>
						<Box styles={{ width: '100%' }}>
							<InputField
								label={resources.inputLabelEmail}
								onClearButtonPress={() => {
									clearInput(getInputProps('email'));
								}}
								{...(getInputProps('email') as Anything)}
							/>
						</Box>
						<Spacer vertical={rem(56)} />
						<Box
							styles={{
								flexDirection: 'column',
								alignItems: 'center',
							}}
						>
							<Box>
								<Button disabled={isDisabled} onPress={onPressSendRequest}>
									{resources.sendRequest}
								</Button>
							</Box>
							<Spacer vertical={rem(56)} />
							<Box>
								<Link onClick={back}>
									<Box styles={{ alignItems: 'center' }}>
										<ArrowLeft fill={colorPalette.color_02[100]} width={rem(24)} height={rem(24)} />
										<Spacer horizontal={rem(8)} />
										<Typography appearance="body-100-03" colorsLevel="linkDefault">
											{resources.linkBack}
										</Typography>
									</Box>
								</Link>
							</Box>
						</Box>
					</Form>
				</Box>
			)}
		</>
	);
};
